import { useQuery, useMutation } from "@tanstack/react-query";
import { jobService } from "@/lib/api/services/job";
import { logger } from "@/lib/logger";
import { Job } from "@/types/career";

type JobQuery = {
  slug?: string;
  search?: string;
  department?: string;
  location?: string;
  employment_type?: string;
  order_by?: "created_at" | "title";
  order_direction?: "asc" | "desc";
};

export function useJobs(filters: JobQuery, initialData?: Job[] | Job) {
  return useQuery({
    queryKey: filters.slug ? ["job", filters.slug] : ["jobs", filters],
    queryFn: async () => {
      try {
        return await jobService.list(filters);
      } catch (error) {
        logger.error("Jobs query failed", {
          error: error instanceof Error ? error.message : String(error),
        });
        throw error;
      }
    },
    staleTime: 60_000,
    initialData,
  });
}


export function useJobApplicationMutation() {
  return useMutation({
    mutationKey: ["submit-job-application"],
    mutationFn: (formData: FormData) =>
      jobService.submitJobApplication(formData),
  });
}
